import { render, staticRenderFns } from "./TyrePill.vue?vue&type=template&id=4dfe180c&scoped=true"
import script from "./TyrePill.vue?vue&type=script&lang=js"
export * from "./TyrePill.vue?vue&type=script&lang=js"
import style0 from "./TyrePill.vue?vue&type=style&index=0&id=4dfe180c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfe180c",
  null
  
)

export default component.exports